import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { SimplePage } from 'common';
import { fetchLegalNotice } from './LegalNoticeSlice';
import { LegalNoticeContentSelector } from './LegalNoticeContentSelector';

export function useLegalNotice(): AbstractContentState<SimplePage> {
    return useCmsContent(fetchLegalNotice, LegalNoticeContentSelector);
}
